import { useAtomValue } from "jotai";

import { FeatureFlagNames, useFeatureFlags } from "@/providers/featureFlags";

import { lastViewedTripIdAtom } from "../atoms/lastViewedTripIdAtom";
import { getCalendarDayInTimezone } from "../utils/tripActiveOnCalendarDay";
import { getTripViewTabTargetPath } from "../utils/tripViewSessionStorage";

import { useTimezone } from "@/hooks/useTimezone";

/** Towers Trip tab/sidebar target (v1 browse landing includes viewer-local today in URL). */
export function useTripViewTabTargetPath(): string {
  const lastViewedTripId = useAtomValue(lastViewedTripIdAtom);
  const { isEnabled } = useFeatureFlags();
  const { tz } = useTimezone();
  const useV1BrowseBehavior = isEnabled(
    FeatureFlagNames.IntelligenceTowerTripViewV1,
  );
  const browseLandingToday = useV1BrowseBehavior
    ? getCalendarDayInTimezone(new Date(), tz.key)
    : undefined;
  return getTripViewTabTargetPath(lastViewedTripId, useV1BrowseBehavior, {
    browseLandingToday,
  });
}
